import Vue from 'vue'
import App from './app/App.vue'
import store from './plugins/store'
import router from './router/router'
import vuetify from './plugins/vuetify';
import JsonCSV from 'vue-json-csv'
import VueRssFeed from 'vue-rss-feed';
import VueMask from 'v-mask';
import VueGraph from 'vue-graph';
import VeeValidate, { Validator } from 'vee-validate'
import CpfValidator from './componentes/validators/cpf.validator';
import Dictionary from './componentes/validators/dictionary';
import VueQrcodeReader from "vue-qrcode-reader";
import "./plugins/vuetify-money.js";
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import  VueVirtualScroller from 'vue-virtual-scroller'
import VueApexCharts from 'vue-apexcharts'

Validator.extend('cpf', CpfValidator)
Vue.use(VeeValidate, {locale: 'pt', dictionary: Dictionary})

Vue.use(VueQrcodeReader);

Vue.use(VueVirtualScroller)

Vue.use(VueMask);

Vue.use(VueGraph)

Vue.use(VueApexCharts)

Vue.component('downloadCsv', JsonCSV)

Vue.component('VueRssFeed', VueRssFeed)

Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false

new Vue({
  VueGraph,
  VueQrcodeReader,
  JsonCSV,
  router,
  store,
  vuetify,
  VeeValidate,
  VueRssFeed,
  VueMask,
  render: h => h(App)
}).$mount('#app')
